<template>
    <div class="main">
        <div class="faq__intro">
            <router-link class="link faq__back" :to="{ name: 'faq' }">
                <img class="fa-rotate-270" src="~@/assets/images/decoration/arrow-up-black.png"
                 alt="Back to FAQs">
                {{ $t('FAQ_QUESTIONS_BACK') }}
            </router-link>

            <slot name="icon"></slot>
            <h2 v-text="category.title"></h2>
            <p class="faq__introDesc" v-text="category.description"></p>
        </div>
        <div class="background--paper p-1 divider--container">
            <div class="divider-white--top"></div>
            <div class="container faqs faq__questions">
                <faq-item
                    v-for="(item, index) in faqItems"
                    :key="index"
                    :item="item"
                    :expand="item.path === $route.path">
                </faq-item>
            </div>
            <div class="divider-white--bottom"></div>
        </div>

        <faq-other-categories></faq-other-categories>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FaqItem from '@/components/partials/faq/FaqItem';
import FaqOtherCategories from '@/components/partials/faq/FaqOtherCategories';

export default {
    name: 'FaqQuestions',
    components: {
        FaqOtherCategories,
        FaqItem,
    },
    props: {
        category: {
            required: true,
            type: Object,
        },
        items: {
            required: true,
            type: Array,
        },
    },
    computed: {
        ...mapGetters({
            isUserLoggedIn: 'auth/isUserLoggedIn',
            pauseEnabled: 'account/getAllowPaused',
        }),
        faqItems() {
            const includePauseQuestions = this.isUserLoggedIn && this.pauseEnabled;
            const filteredByAuthStatus = this.items.filter(item => item.loggedIn === this.isUserLoggedIn);
            const filteredPauseQuestions = filteredByAuthStatus.filter(item => {
                const includeQuestion = includePauseQuestions ? true : !item.pauseEnabled;
                return includeQuestion;
            });
            return filteredPauseQuestions;
        },
    },
};
</script>
